import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from '@sparrow-card/sparrow-card-constants';

const DEFAULT_TITLE = 'Sparrow | Get Started';

const ROUTE_TITLES: Record<string, string> = {
  [AppRoutes.Apply]: 'Sparrow | Get Started',
  [AppRoutes.Verify]: 'Sparrow | Phone Verification',
  [AppRoutes.DocumentVerification]: 'Sparrow | Document Verification',
  [AppRoutes.DocumentVerificationResult]: 'Sparrow | Verification Result',
  [AppRoutes.Decline]: 'Sparrow | Application Declined',
  [AppRoutes.Approval]: 'Sparrow | Application Approved',
  [AppRoutes.Locked]: 'Sparrow | Locked',
  [AppRoutes.Review]: 'Sparrow | Application Under Review',
  [AppRoutes.Canceled]: 'Sparrow | Application Canceled',
  [AppRoutes.PreApproved]: 'Sparrow | Get Started',
  [AppRoutes.OfferCodeExpired]: 'Sparrow | Offer Code Expired',
  [AppRoutes.PreApprovedLocked]: 'Sparrow | Locked',
  [AppRoutes.OfferCodeUsed]: 'Sparrow | Offer Code Used',
};

export const usePageTitle = (customTitle?: string) => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = customTitle || ROUTE_TITLES[path] || DEFAULT_TITLE;

    document.title = title;
  }, [location.pathname, customTitle]);
};
